'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/chart-pricing-departure-dates-tooltip-template.html'));
var ChartPricingDepartureDatesController = function ChartPricingDepartureDatesController($scope, $rootScope, $filter, $timeout, formatter, momentService, dataProviderService, legendFilterService) {
  var maxSelectionSize = 45;
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  function dataFunction() {
    return $scope.data;
  }
  function reloadChart() {
    $scope.setLoadingMessage();
    return dataProviderService.getData().then(function (chartData) {
      $scope.departureDates = chartData.originalDepartureDates;
      $scope.data = chartData.data;
      $scope.renderChart($scope.data, calculateSelectionSize($scope.data));
      if ($scope.data.length === 1) {
        $timeout(function () {
          $scope.selectDepartureDate(_.first($scope.data), 0);
        }, 0);
      }
    });
  }
  $scope.initChart = function () {
    reloadChart().then(function () {
      $scope.$broadcast('Chart:departureDates:reloadFilters');
      $scope.$emit('network-analysis:dataLoaded');
    });
  };
  $scope.invalidateData = function () {
    dataProviderService.invalidateCache();
  };
  $scope.chartFormatters = {
    yAxisTickFormatter: formatter.humanReadable,
    xAxisTickFormatter: formatter.momentWithYearTick('DAY_MONTH_SHORT_NAME_YEAR', 'DAY_MONTH_SHORT_NAME', 'DAY_OF_MONTH', 'departureDateMoment', dataFunction, true),
    tooltipFormatter: function tooltipFormatter(d) {
      var tooltipModel = {
        date: rmMomentFormat(d.departureDateMoment, 'DATE_USER_SETTINGS'),
        averageFareChange: rmNumberFormat(d.m1, 'NUMBER'),
        averageFareChangeLabel: 'Avg Eff Fare Change',
        recommendations: rmNumberFormat(d.m2, 'NUMBER'),
        recommendationsLabel: 'RECOMMENDATIONS',
        numberOfEffectedServices: rmNumberFormat(d.m3, 'NUMBER'),
        numberOfEffectedServicesLabel: 'Effected Services',
        numberOfEffectedServicesNew: rmNumberFormat(d.numberOfEffectedServicesNew, 'NUMBER'),
        numberOfEffectedServicesNewLabel: 'New',
        numberOfEffectedServicesExtensions: rmNumberFormat(d.numberOfEffectedServicesExtensions, 'NUMBER'),
        numberOfEffectedServicesExtensionsLabel: 'Extensions',
        numberOfEffectedServicesExcluded: rmNumberFormat(d.m4, 'NUMBER'),
        numberOfEffectedServicesExcludedLabel: 'Excluded Services'
      };
      return tooltipTemplate(tooltipModel);
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'date-range-chart-tooltip';
  $scope.viewportFormatters = {
    xAxisTickFormatter: formatter.momentWithYearTick('MONTH_YEAR', 'MONTH', undefined, 'departureDateMoment', dataFunction)
  };
  function setAllBarsSelection(isSelected) {
    _.forEach($scope.data, function (departureDate) {
      departureDate.selected = isSelected;
    });
  }
  function saveLegendFilterState(selectedDepartureDate) {
    legendFilterService.setSelectedDepartureDate(selectedDepartureDate.departureDateMoment);
    legendFilterService.setSelectedCarrier(selectedDepartureDate.carrier);
  }
  function calculateSelectionSize(data) {
    return data.length > maxSelectionSize ? maxSelectionSize : data.length;
  }
  $scope.selectDepartureDate = function (selectedDepartureDate, selectedDepartureDateIndex) {
    setAllBarsSelection(false);
    selectedDepartureDate.selected = true;
    saveLegendFilterState(selectedDepartureDate);
    var eventArgs = _.pick(selectedDepartureDate, 'departureDateMoment', 'eventTimeStampMoment', 'market', 'pos', 'carrier', 'cabin');
    $rootScope.$broadcast('chart:DepartureDate:selectedDepartureDate', eventArgs, selectedDepartureDateIndex);
    $scope.renderChart($scope.data, calculateSelectionSize($scope.data));
  };
  $scope.selectAllDepartureDate = function () {
    if (_.isEmpty($scope.data)) {
      return;
    }
    setAllBarsSelection(true);
    $scope.renderChart($scope.data, calculateSelectionSize($scope.data));
  };
  $scope.viewportReset = function () {
    $scope.resetRange();
    $scope.renderChart($scope.data, calculateSelectionSize($scope.data));
  };
  $scope.resetRange = function () {
    $scope.currentRange = undefined;
  };
};
ChartPricingDepartureDatesController.$inject = ['$scope', '$rootScope', '$filter', '$timeout', 'FormatterService', 'MomentService', 'ChartPricingDepartureDatesDataProviderService', 'PricingDepartureDatesLegendFilterService'];
module.exports = ChartPricingDepartureDatesController;